<template>
    <!-- @* #region 委托代卖 *@ -->
    <el-dialog v-if="dialogEntrustSaleVisible" :title="entrustProcess == 1 ? $t('vault.SelectManagedSeller') : (entrustProcess == 2 ? $t('vault.SelectMyCards') : $t('vault.ConsignforSale'))" :visible.sync="dialogEntrustSaleVisible" :custom-class="`entrust-sale-dialog sale-dialog-${this.entrustProcess}`" top="10vh" :before-close="handleEntrustSaleClose" :close-on-click-modal="false" :close-on-press-escape="false">

        <div class="entrustSale-main-box">
            <div class="entrust-sale-box">
                <!-- @* 选择代卖商家 *@ -->
                <div class="entrust-sale-block select-sale" v-show="entrustProcess == 1">
                    <div class="tips-row tips-blue" v-if="DetailStartBid && DetailStartBid.StartBidRatio">
                        {{ $t('vault.consignedCards', { n: formatPercent(DetailStartBid.StartBidRatio ? numMulti(DetailStartBid.StartBidRatio, 100) : 100) }) }}
                    </div>
                    <div class="entrust-header">
                        <div v-if="CardApplyType != 'SingleCardApply'" v-on:click="checkType('', '')" v-bind:class="[!currentCategoryId ? 'onActive' : '']">{{ $t('base.all') }}</div>
                        <template v-if="CardApplyType == 'SingleCardApply'">
                            <div v-on:click="checkType(item.Id, item)" v-for="(item, index) in CategoryLabels" v-bind:key="index" v-if="currentCategoryId == item.Id" v-bind:class="['onActive']">{{ item.EnName }}</div>
                        </template>
                        <template v-else>
                            <div v-on:click="checkType(item.Id, item)" v-for="(item, index) in CategoryLabels" v-bind:key="index" v-bind:class="[currentCategoryId == item.Id ? 'onActive' : '']">{{ item.EnName }}</div>
                        </template>
                    </div>

                    <div class="entrust-wrapper seller-list" :loading="searchLoading">
                        <template v-if="searchLoading">
                            <div style="color:#999;text-align:center;font-size:16px;line-height:2">
                                Loading ...
                            </div>
                        </template>
                        <template v-else>
                            <div :class="['entrust-seller-block', k == cSellerIndex ? 'active' : '', { offline: obj.OnlineStatus === 0 }]" v-for="(obj, k) in sellerList" v-bind:key="k" v-on:click="selectSeller(obj, k)">
                                <div class="mark" v-if="obj.OnlineStatus === 0"></div>
                                <div class="ent-avatar">
                                    <el-image class="avatar-img" :src="`${obj.ProfileImgUrl || '/Content/img/headimg.png'}?imageView2/2/h/100`" fit="contain">
                                    </el-image>
                                </div>
                                <div class="seller-info">
                                    <div class="sel-info-header">
                                        <div class="sel-info-left">
                                            <div class="nickname">{{ obj.RealName }}</div>
                                            <div class="favorable">
                                                {{ $t('vault.positive') }}
                                                {{ positiveRating(obj) }}
                                                <!-- {{ obj.SellFavorableSum }} -->
                                            </div>
                                        </div>
                                        <div class="sel-info-right" v-if="obj.OnlineStatus === 1">
                                            <i v-if="k == cSellerIndex" class="el-icon-success"></i>
                                            <span v-else class="radio-icon"></span>
                                        </div>
                                    </div>
                                    <div class="entrust-tags">
                                        <el-tag class="tags" v-for="item in obj.SellerTags" :key="item.NameEn" :type="item.NameEn" effect="plain">
                                            {{ item.NameEn }}
                                        </el-tag>
                                    </div>
                                    <div class="seller-desc">
                                        <ul>
                                            <li v-if="obj.Categorys.length">
                                                {{ $t('vault.ConsignmentType') }}：
                                                <span class="tags" v-for="(item, k) in obj.Categorys" :key="item.ChName" :type="item.ChName" effect="plain">
                                                    {{ item.EnName }}
                                                    {{ k < (obj.Categorys.length - 1) ? "、" : "" }} </span>
                                            </li>
                                            <li v-if="obj.USDAmountLimit > 0">{{ $t('vault.AcceptCardsValued', { n: ('USD ' + ThousandAndDecimal(obj.USDAmountLimit)) }) }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="entrust-footer">
                        <div class="select-seller-box">
                            <div class="current-seller" v-if="currentSeller._id">
                                <div class="cs-block cs-left">
                                    <span>{{ $t('vault.SelectedSeller') }}</span>
                                    <div>{{ currentSeller.RealName }}</div>
                                </div>
                                <div class="cs-block cs-right pointer" v-on:click="toggleCommission(true)">
                                    <span>{{ $t('vault.EstimatedCommission') }}</span>
                                    <div class="proportion">{{ ratioFilter(currentSeller.RatioConfigs) }}%<i class="arrow"></i></div>
                                </div>
                            </div>
                            <div class="commission" v-show="commissionShow">
                                <div class="commission-mark" v-on:click="toggleCommission(false)"></div>
                                <div class="commission-main">
                                    <div class="comm-title">
                                        {{ $t('vault.EstimatedCommission') }}
                                        <span class="close" v-on:click="toggleCommission(false)"></span>
                                    </div>
                                    <div class="comm-list">
                                        <el-table v-bind:data="currentSeller.RatioConfigs" stripe style="width: 100%" max-height="300" v-bind:cell-style="{ textAlign: 'center' }" v-bind:header-cell-style="{ textAlign: 'center' }">
                                            <el-table-column label="USD">
                                                <template slot-scope="scope">
                                                    <span style="margin-left: 10px">
                                                        <template v-if="currentSeller.RatioConfigs.length == scope.$index + 1">
                                                            {{ $t('vault.andAbove', { n: scope.row.TransactionAmountMin }) }}
                                                        </template>
                                                        <template v-else>
                                                            {{ scope.row.TransactionAmountMin }} - {{ scope.row.TransactionAmountMax }}
                                                        </template>
                                                    </span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :label="$t('vault.Commission')">
                                                <template slot-scope="scope">
                                                    <span style="margin-left: 10px">
                                                        {{ numAdd(scope.row.SellerRatio, scope.row.PlatformRatio) }} %
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                    <div class="tips-row tips-blue" style="text-align: center;">
                                        {{ $t('vault.CommissionIncludes') }}
                                        <br>{{ $t('vault.transactionCompleted') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="operate-btns">
                            <div v-on:click="handleEntrust(2, cSellerIndex !== -1)" class="opt-btn opt-confirm" :class="{ disabled: cSellerIndex === -1 }">{{ $t('base.confirm') }}</div>
                        </div>
                    </div>
                </div>
                <!-- @* 选择商品 *@ -->
                <div class="entrust-sale-block confirm-entrust" v-show="entrustProcess == 2 && !CardApplyType">
                    <div class="entrust-side">
                        <ul>
                            <li v-if="currentSeller.AmountLimit > 0">{{ $t('vault.ConsignmentPrice') }}：{{ $t('vault.Above', { n: ('USD ' + ThousandAndDecimal(currentSeller.AmountLimit)) }) }}</li>
                            <li v-if="currentSeller.Categorys">
                                {{ $t('vault.ConsignmentType1') }}：
                                <span class="tags" v-for="(item, k) in currentSeller.Categorys" :key="item.EnName" :type="item.EnName" effect="plain">
                                    {{ item.EnName }}
                                    {{ k < (currentSeller.Categorys.length - 1) ? "、" : "" }} </span>
                            </li>
                        </ul>
                    </div>
                    <div class=" entrust-wrapper goods-list" :loading="searchLoading">
                        <div class="goods-header">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" v-on:change="handleCheckAllChange">
                                {{ $t('vault.CardsToConsign') }} <span>({{ checkedList.length ? checkedList.length : 0 }}/{{ maxLength }})</span>
                            </el-checkbox>
                            <div>{{ $t('vault.MatchingCards') }}</div>
                        </div>
                        <el-checkbox-group v-model="checkedList" v-on:change="handleCheckedChange">
                            <div class="goods-row" v-for="(obj, k) in complyGoodsList" v-bind:key="k">
                                <!-- @*<div class="checkbox-wrapper">
                                                            <el-checkbox v-bind:label="obj">&nbsp;</el-checkbox>
                                                        </div>*@ -->
                                <el-checkbox v-bind:label="obj">
                                    <div class="goods-content">
                                        <el-image class="goods-img" :src="`${obj.TitImg || '/Content/img/headimg.png'}?imageView2/2/h/100`" fit="contain">
                                        </el-image>
                                        <div class="goods-info">
                                            <div class="goods-title two-line">
                                                {{ obj.Title }}
                                            </div>
                                            <div class="goods-desc">
                                                {{ jsonValue(obj.PropertyJson) }}
                                            </div>
                                            <div class="goods-price">
                                                USD {{ ThousandAndDecimal(obj.UsdPrice) }}
                                            </div>
                                        </div>
                                    </div>
                                </el-checkbox>
                            </div>
                        </el-checkbox-group>
                    </div>
                    <!-- @* 分页 *@ -->
                    <div class="block_pagination" style="margin-top:5px">
                        <!-- @*layout="total, sizes, prev, pager, next" *@ -->
                        <el-pagination v-on:size-change="seachSizeChange" v-on:current-change="seachCurrentChange" :current-page.sync="seachComplyGoodsForm['PageIndex']" :page-size="seachComplyGoodsForm['PageSize']" :page-sizes="[10, 20, 50, 100]" layout="total,sizes" :total="seachPageTotal">

                        </el-pagination>
                    </div>
                    <div class="entrust-footer">
                        <div class="operate-btns">
                            <div v-on:click="handleEntrustBack(1)" class="opt-btn opt-goback">{{ $t('base.back') }}</div>
                            <div v-on:click="handleEntrust(3, checkedList.length > 0)" class="opt-btn opt-confirm" :class="{ disabled: checkedList.length <= 0 }">{{ $t('base.next') }}</div>
                        </div>
                    </div>
                </div>
                <!-- @* 委托代卖 *@ -->
                <div class="entrust-sale-block confirm-entrust" v-show="entrustProcess == 3">
                    <div class="cSeller-info-box">
                        <div class="ent-avatar">
                            <el-image class="avatar-img" :src="`${currentSeller.ProfileImgUrl || '/Content/img/headimg.png'}?imageView2/2/h/100`" fit="contain">
                            </el-image>
                        </div>
                        <div class="seller-info">
                            <div class="sel-info-header">
                                <div class="sel-info-left">
                                    <div class="nickname">{{ currentSeller.RealName }}</div>
                                    <div class="favorable">{{ $t('base.positive') }} {{ positiveRating(currentSeller) }}</div>
                                </div>
                                <div class="sel-info-right">
                                    <router-link class="go-shop" :to="{ path: `/seller/detail/${currentSeller.MemberId}` }" target="_blank"></router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="code-name-box">
                        <div class="cname-tips">
                            <b>{{ $t('vault.ConsignerTag') }}</b><em style="color:#f00">*</em>&nbsp;
                            <span>
                                ({{ $t('vault.cardtitleoncelisted') }})
                            </span>
                        </div>
                        <el-input v-model="FormDataApply['Consignor']" :placeholder="$t('vault.EnterYourConsignerTag')" maxlength="10" :show-word-limit="true"></el-input>
                    </div>
                    <div class="entrust-wrapper goods-list wrapper-fill">
                        <div class="entrust-title">
                            <b>{{ $t('vault.ConsignmentList') }}</b>
                            <span>{{ checkedList.length }}{{ $t('base.items') }} / {{ $t('vault.Estimated', { n: 'USD ' + estimatedValue }) }}</span>
                        </div>
                        <div class="goods-row" v-for="(obj, k) in checkedList" v-bind:key="k">
                            <div class="goods-content">
                                <el-image class="goods-img" :src="`${obj.TitImg || '/Content/img/headimg.png'}?imageView2/2/h/100`" fit="contain">
                                </el-image>
                                <div class="goods-info">
                                    <div class="goods-title two-line">
                                        {{ obj.Title }}
                                    </div>
                                    <div class="goods-desc" v-if="obj.PropertyJson">
                                        {{ jsonValue(obj.PropertyJson) }}
                                    </div>
                                    <div class="goods-price">
                                        USD{{ ThousandAndDecimal(obj.UsdPrice) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="entrust-footer">
                        <div class="">
                            <div class="sel-info-right">
                                <div v-on:click="ifAgreement(vaultAgreementType)">
                                    <div class="agreement-side">
                                        <div v-if="vaultAgreement" class="el-icon-success"></div>
                                        <i v-else class="radio-icon"></i>
                                    </div>
                                    <span>{{ $t('vault.agreeToVault') }}</span>
                                </div>
                                <router-link :to="{ path: '/terms/privacy', query: { type: vaultAgreementType } }" target="_blank">{{ $t('vault.ConsignmentSaleAgreement') }}</router-link>{{ $t('vault.accurateAndcomplete') }}
                            </div>
                        </div>
                        <div class="operate-btns">
                            <div v-on:click="handleEntrustBack(CardApplyType == 'SingleCardApply' ? 1 : 2)" class="opt-btn opt-goback">{{ $t('base.back') }}</div>
                            <div v-on:click="handleEntrust('submit', vaultAgreement)" class="opt-btn opt-confirm" :class="{ disabled: !vaultAgreement }">{{ $t('vault.SubmitConsignment') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
    <!-- @* #endregion *@ -->

</template>
<script>

import { getInfo, signAgreement } from "@/api/public";
import commonEventJs from "@/common/CommonEventJs.js";
import Categories from '@/common/Category.js';
import { t } from "element-ui/lib/locale";

export default {
    name: 'VaultEntrustSale',
    data() {
        return {
            maxLength: 100,
            userInfo: getInfo(),

            token: getInfo().ChineseToken, // 用户token
            MemberId: getInfo().MappingUserId, // 用户ID 
            UserId:getInfo().Id,  // 海外ID用户ID
            MemberMobile: getInfo().TelPhone,
            MemberRealName: getInfo().NickName,

            //委托代卖
            AccountId: commonEventJs.GetAccountInfo(),
            searchLoading: false,//列表搜索loading
            entrustSaleBtnShow: false,//委托代卖按钮 待获取钱包信息后显示
            dialogEntrustSaleVisible: false,//委托代卖弹框
            entrustProcess: 1,//选择委托代卖流程 1：选择商家 2：选择商品 3：确认提交委托
            CategoryLabels: [],//代卖标签
            sellerList: [],//代卖卖家列表
            sellingList: [],//已委托的代卖卖家，代卖筛选列表
            SellerUserId: null,//代卖人id
            currentSeller: {},//已选商家
            cSellerIndex: -1,//已选商家的列表键值
            commissionShow: false,//是否显示佣金列表
            seachComplyGoodsForm: {
                MemberId: getInfo().MappingUserId,
                PageIndex: 1,
                PageSize: 10,
            },
            isIndeterminate: false,
            checkedList: [],
            checkAll: false,
            complyGoodsList: [],//符合代卖人的商品列表
            seachPageTotal: 0,
            estimatedValue: 0,//预估总值
            submitApplyLoading: false,
            vaultAgreement: false,//是否同意委托代卖协议
            vaultAgreementType: 21,
            FormDataApply: {
                MemberId: getInfo().MappingUserId,
                RealName: getInfo().NickName,
                Remark: '',//备注
                Consignor: '',//标识 以后签入标题中
            },
            CardApplyType: null,//商品委托类型：null 默认，SingleCardApply单卡委托
            updateStatusloading: false,//撤销代码 加载中
            DetailStartBid: null,//起拍价比例
            currentCategoryId: null,//null/空 默认全部
        }
    },
    props: {
        vaultDetail: {
            type: Object,
            default: {}
        },
        VaultId: {
            type: String,
            default: ''
        }
    },
    watch: {
        checkedList: {
            //estimatedValue
            handler(data) {
                //console.log('watch-checkedList',data)
                const total = data.reduce((sum, item) => {
                    const price = item.UsdPrice||item.EstimatePrice;
                    // 将价格转换为数字并累加
                    return sum + (Number(price) || 0);
                }, 0);
                this.estimatedValue = this.ThousandAndDecimal(total);
            },
        },
    },
    computed: {
        ThousandAndDecimal() {
            return function (num) {
                //金额千分位
                return commonEventJs.thousandAndDecimal(num);
            }
        },
        ratioFilter() {
            return function (data) {
                //console.log('ratioFilter',data);
                if (data.length) {
                    const minItem = data.reduce((min, current) => {
                        return current.SellerRatio < min.SellerRatio ? current : min;
                    });
                    return commonEventJs.numAdd(minItem.SellerRatio, minItem.PlatformRatio)
                } else {
                    return ''
                }
            }
        },
        positiveRating() {
            return function (data) {
                let positive = 0;
                const sum = (data.BuyFavorableCount + data.BuyNegativeCount + data.SellFavorableCount + data.SellNegativeCount);
                if (sum !== 0) {
                    positive = ((data.BuyFavorableCount + data.SellFavorableCount) / sum) * 100;
                }
                return this.formatPercent(positive);
            }
        },
        numAdd() {
            return function (num1, num2) {
                return commonEventJs.numAdd(num1, num2)
            }
        },
        numMulti() {
            return function (num1, num2) {
                return commonEventJs.numMulti(num1, num2)
            }
        },
        jsonValue() {
            //PropertyJson
            return function (json) {
                var decodeJson = JSON.parse(decodeURIComponent(json))
                var val = "";
                if (decodeJson.ProfessionalGrader) {
                    val = decodeJson.ProfessionalGrader + ' ' + (decodeJson.Grade ? decodeJson.Grade : '');
                }
                return val;
            }
        },
        disabled() {
            return this.noMore
        },
    },
    created() {
        let that = this
        that.GetStartBidRatio()//获取起拍价比例
        // that.GetSellingList()
        that.GetCategoriesV1()
        console.log('entrust-sale.vaultDetail', that.vaultDetail)
    },
    methods: {
        formatPercent(value) {
            const number = Number(value);
            if (!Number.isFinite(number)) return '0%';
            const formatted = number.toFixed(2).replace(/\.?0+$/, '');
            return `${formatted}%`;
        },
        //委托代卖
        GetStartBidRatio() {
            //获取起拍价比例
            const that = this;
            var parm = {}
            const fun = function (res) {
                //console.log("GetStartBidRatio",res)
                if (res.Result == 1) {
                    that.DetailStartBid = res.Data
                } else {
                }
            }
            that.$get(that.$interface['GetStartBidRatio'], parm).then(res => {
                fun(res)
            });
        },
        GetCategoriesV1() {
            const that = this;
            let result = Categories.GetCategoriesList[0].FirstCategory;
            const SecondCategories = result.SecondCategories;
            SecondCategories.map(item => {
                const data = {
                    Id: item.Category._id,
                    ChName: item.Category.ChName,
                    EnName: item.Category.EnName,
                    IsEnable: false
                };
                that.CategoryLabels = [...that.CategoryLabels, data];
            });
        },
        UpdateApplyStatus(obj) {
            //修改代卖卡状态 撤销代卖
            var that = this;
            if (that.updateStatusloading) return;
            that.$confirm(that.$t('vault.ConfirmCancelConsignment'), that.$t('base.hint'), {
                confirmButtonText: that.$t('base.confirm'),
                cancelButtonText: that.$t('base.cancel'),
                type: 'warning'
            }).then(() => {
                that.updateStatusloading = true;
                var parm = { SellerApplyIds: [obj.SellerApplyId], ApplyStatus: 4 }
                const fun = function (res) {
                    //console.log("UpdateApplyStatus",res)
                    if (res.Result == 1) {
                        // that.GetSellingList()
                        that.$emit('handleRefreshCommodity', that.vaultDetail);
                        setTimeout(function () {
                            that.updateStatusloading = false;
                        }, 2000)
                    } else {
                        that.updateStatusloading = false;
                    }
                }
                /*
                    ApplyStatus: 申请状态 0 待审核 1 审核通过 3审核驳回  4 卡主撤销代卖
                */
                that.$post(that.$interface['UpdateApplyStatus'], parm).then(res => {
                    fun(res)
                });
            }).catch(() => { });
        },
        entrustSaleDialog(prams = {}) {
            const that = this;
            // const isWallet = that.isWallet;
            this.dialogEntrustSaleVisible = true;
            this.GetSellerList(prams);
        },
        handleEntrustSaleClose() {
            this.dialogEntrustSaleVisible = false;
            this.cSellerIndex = -1;
            this.currentSeller = {};
            this.entrustProcess = 1;//选择委托代卖流程 1：选择商家 2：选择商品  3：确认提交

            this.isIndeterminate = false;
            this.checkedList = [];
            this.checkAll = false;
            this.complyGoodsList = [];//符合代卖人的商品列表
            this.submitApplyLoading = false;
            this.vaultAgreement = false;
        },
        handleEntrustBack(val) {
            this.entrustProcess = val || 1;
            switch (val) {
                case 1:
                    if (this.CardApplyType != 'SingleCardApply') {
                        this.checkedList = []
                    }
                    this.isIndeterminate = false
                    this.checkAll = false
                    break;
                case 2:
                    this.vaultAgreement = false
                    break;
                default:
                    break;
            }
        },
        handleEntrust(val, nextStatus = false) {
            //委托代卖 - 处理流程 选择、确认
            const that = this;
            if (!nextStatus) return;
            if (val == 'submit') {
                //console.log('submit')
                //提交委托申请
                if (that.checkedList.length <= 0) {
                    //that.$t('vault.SelectCardsConsign')
                    that.$confirm(that.$t('vault.SelectCardsConsign'), that.$t('base.hint'), {
                        confirmButtonText: that.$t('base.confirm'),
                        cancelButtonText: that.$t('base.cancel'),
                        type: 'warning'
                    });
                } else {
                    let Consignor = that.FormDataApply['Consignor'] ? that.FormDataApply['Consignor'].trim() : '';
                    if (!Consignor) {
                        this.$message({
                            message: this.$t('vault.EnterYourConsignerTag'), // '请输入您的委托人标识！',
                            type: 'warning',
                            offset: 350
                        });
                        return
                    }

                    //that.$t('vault.ConfirmConsignmentRequest')
                    that.$confirm(that.$t('vault.ConfirmConsignmentRequest'), that.$t('base.hint'), {
                        confirmButtonText: that.$t('base.confirm'),
                        cancelButtonText: that.$t('base.cancel'),
                        type: 'info'
                    }).then(() => {
                        if (that.submitApplyLoading) return;
                        that.submitApplyLoading = true;
                        signAgreement(that.vaultAgreementType);//提交协议

                        let CommodityIds = that.checkedList.map(item => item._id);
                        const currentSeller = that.currentSeller;
                        var parm = {
                            ...that.FormDataApply,
                            CommodityIds,
                            Consignor,
                            MemberId: getInfo().MappingUserId,
                            RealName: getInfo().NickName,
                            SellerMemberId: currentSeller.MemberId,
                            SellerRealName: currentSeller.RealName
                        }
                        const fun = function (res) {
                            if (res.Result == 1) {
                                that.$message.success('申请成功');
                                that.handleEntrustSaleClose();
                                // that.GetSellingList()
                                console.log('handleEntrust.vaultDetail', that.vaultDetail)
                                that.$emit('handleRefreshCommodity', that.vaultDetail);
                                setTimeout(() => {
                                    that.submitApplyLoading = false;
                                    if (that.CardApplyType == 'SingleCardApply') {
                                        that.currentCategoryId = null;
                                    }
                                }, 1000)
                            } else {
                                that.$message.error('申请失败：' + res.Msg);
                                that.submitApplyLoading = false;
                            }
                        }
                        that.$post(that.$interface['SaveSellerApply'], parm).then(res => {
                            fun(res)
                        });
                    }).catch(() => { });
                }
            } else {
                if (that.CardApplyType == 'SingleCardApply') val = 3;//单卡委托 跳过选择商品
                that.entrustProcess = val || 1;
                if (val === 2) {
                    that.GetCardCommodityByPage();
                }
            }

        },
        GetSellerList(parms = {}) {
            //获取商户列表
            const that = this;
            that.searchLoading = true;
            that.sellerList = [];
            const fun = function (res) {
                // console.log("GetSellerUserByPage",res)
                if (res.Result == 1) {
                    that.sellerList = res.Data || [];
                }
                that.searchLoading = false;
            }
            var parm = { pageIndex: 1, pageSize: 999, LoginMemberId: getInfo().MappingUserId, ...parms }
            that.$post(that.$interface['GetSellerUserByPage'], parm).then(res => {
                fun(res)
            });

        },
        checkType(id, item) {
            const that = this;
            this.currentCategoryId = id
            console.log('checkType', id, item)
            this.GetSellerList({ CategoryId: id });
        },
        selectSeller(obj, key) {
            //勾选代卖
            const that = this;
            if (obj.OnlineStatus === 0) return;
            that.cSellerIndex = key;
            that.currentSeller = obj;
        },
        toggleCommission(type) {
            this.commissionShow = type;
        },
        GetCardCommodityByPage() {
            //获取符合代卖的商品列表
            const that = this;
            const currentSeller = that.currentSeller;
            const Categorys = currentSeller.Categorys || [];
            let CategoryIds = [];
            if (Categorys.length) {
                CategoryIds = Categorys.map(item => item.Id);
            }
            console.log('VaultId', that.VaultId)
            var parm = {
                ...that.seachComplyGoodsForm,
                CategoryIds,
                VaultId: that.VaultId,
                AmountLimit: -1,//金额限定 -1 无限制
            }
            const fun = function (res) {
                if (res.Result == 1) {
                    that.complyGoodsList = res.Data || [];
                    that.seachPageTotal = res.Count || 0;
                } else {
                    that.complyGoodsList = [];
                    that.seachPageTotal = 0;
                }
            }
            that.$post(that.$interface['GetCardCommodityByPage'], parm).then(res => {
                fun(res)
            });
        },
        seachSizeChange(val) {
            //console.log(`每页 ${val} 条`);
            const that = this;
            this.checkedList = [];
            this.checkAll = 0;
            this.isIndeterminate = false;

            that.$set(that.seachComplyGoodsForm, 'PageSize', val);
            that.GetCardCommodityByPage();
        },
        seachCurrentChange(val) {
            //console.log(`当前页: ${val}`);
        },
        handleCheckAllChange(val) {
            let CategoryIds = [];
            if (this.complyGoodsList.length) {
                CategoryIds = this.complyGoodsList.map(item => item._id);
            }
            this.checkedList = val ? this.complyGoodsList : [];
            this.isIndeterminate = false;
            //console.log("checkedList",this.checkedList)
        },
        handleCheckedChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.complyGoodsList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.complyGoodsList.length;
            //console.log("checkedList",this.checkedList)
        },
        handleVaultAgreement() {
            //console.log('vaultAgreement',this.vaultAgreement)
        },
        //多卡委托（先选人）
        MultiCardApply() {
            const that = this;
            that.CardApplyType = null;
            that.currentCategoryId = null;
            that.entrustSaleDialog()
        },
        //单卡委托（先选卡）
        SingleCardApply(item) {
            const that = this;
            console.log('SingleCardApply', item)
            // console.log('SingleCardApply-prams', item, item.SecondCategoryName, item.SecondCategoryId, item.EstimatePrice)
            that.CardApplyType = 'SingleCardApply';
            that.currentCategoryId = item.SecondCategoryId;
            that.checkedList = [{ ...item }]
            //item.EstimatePrice人民币货值、UsdPrice美金货值
            // that.entrustSaleDialog({ CategoryId: item.SecondCategoryId, AmountLimit: item.EstimatePrice })
            that.entrustSaleDialog({ CategoryId: item.SecondCategoryId, AmountLimit: item.UsdPrice })
        },
        //同意协议
        ifAgreement(agreeId) {
            let isAgree = true;// !this.vaultAgreement;
            if (!this.vaultAgreement) {
                this.vaultAgreement = isAgree;
            }
        }
    }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* / */
.pointer {
    cursor: pointer;
}


.tips-row {
    padding: 10px;
    font-size: 14px;
    background: #efefef;
    color: #666;
    margin-bottom: 10px;
}

.tips-blue {
    background: #e2efff !important;
    color: #2059A1 !important;
}

.txt-gray {
    color: #A0A0A0;
}


/* 按钮 */
.operate-btns {
    display: flex;
    padding: 15px 0;
    width: 100%;
}

.opt-btn {
    background: #2059A1;
    color: #fff;
    line-height: 3;
    border: 1px solid #2059A1;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    opacity: 0.8;
}

.opt-btn:hover {
    opacity: 1;
}

.opt-btn.disabled {
    background: #999;
    border-color: #888;
}

.opt-goback {
    width: 30%;
    margin-right: 10px;
    border-color: #666;
    color: #666;
    background: #fff;
}

.opt-confirm {
    flex: 1;
}

.close {
    display: inline-block;
    width: 20px;
    height: 20px;
    /* background: url("/Content/img/close.svg") no-repeat 50% 50%; */
    background: url("/static/images/close.png") no-repeat 50% 50%;
    background-size: contain;
    cursor: pointer;
}


.block_pagination {
    text-align: right;
    margin-top: 15px;
}

/* 委托代卖 */

.txt-gray {
    color: #A0A0A0;
}

/deep/ .entrust-sale-dialog .el-dialog__body {
    padding: 0;
    background: #F7F7F7;
}

.entrust-sale-box {
    position: relative;
}

.entrust-side {
    color: #333;
    padding: 20px;
    background: #F7F7F7;
}

.entrust-wrapper {
    padding: 20px;
    min-height: 300px;
    max-height: 500px;
    overflow-y: auto;
}

.entrust-wrapper.wrapper-fill {
    padding: 0 20px;
}

.wrapper-fill .goods-row {
    padding: 0 20px;
}

.wrapper-fill .entrust-title {
    color: #333;
    padding: 10px 0;
}

.wrapper-fill .entrust-title span {
    color: #A0A0A0;
}

.entrust-header {
    padding: 10px;
    background: #fff;
}

.entrust-header div {
    display: inline-block;
    padding: 4px 5px;
    margin: 0 5px 0 0;
    border-radius: 5px;
    cursor: pointer;
    font-size: 13px;
}

.entrust-header .onActive {
    color: #fff;
    background: #2059A1;
}

.entrust-seller-block {
    margin: 0 0 15px;
    border: 1px solid #fff;
    background: #fff;
    border-radius: 10px;
    padding: 10px;
    display: flex;
    cursor: pointer;
}

.entrust-seller-block:hover {
    box-shadow: 0 0 10px 3px #eee;
}

.entrust-seller-block.active {
    border-color: #2059A1;
}

.entrust-seller-block.active:hover {
    box-shadow: 0 0 5px #2059A1;
}

.entrust-seller-block.offline {
    border-color: #dedede;
    cursor: auto;
    position: relative;
    overflow: hidden;
}

.entrust-seller-block.offline .mark {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    background: rgba(150, 150, 150, .1);
    z-index: 1;
}

.ent-avatar {
    width: 60px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
}

.avatar-img {
    width: 50px;
    height: 50px;
    background: #fff;
    box-shadow: 0 0 3px #efefef;
    border-radius: 50%;
    overflow: hidden;
}

.seller-info {
    flex: 1;
}

.sel-info-header {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
}

.el-icon-success,
.radio-icon {
    color: #2059A1;
    display: block;
    font-size: 18px;
    width: 18px;
    height: 18px;
}

.radio-icon {
    border: 1px solid #999;
    border-radius: 50%;
    width: 16px;
    height: 16px;
}

.entrust-tags {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #F0F0F0;
}

.entrust-tags .tags {
    margin: 0 10px 5px 0;
}

.seller-desc {
    color: #888;
}

.seller-desc ul,
.seller-desc ul li {
    list-style-type: disc;
    margin-left: 10px;
}

.entrust-footer {
    padding: 10px 20px;
    background: #fff;
    border-top: 1px solid #efefef;
}

.entrust-footer .sel-info-right {
    color: #333;
}

.entrust-footer .sel-info-right>div {
    display: inline-flex;
    align-items: baseline;
    cursor: pointer;
}

.entrust-footer .agreement-side {
    display: flex;
    padding-right: 22px;
    position: relative;
}

.entrust-footer .radio-icon {
    position: absolute;
    top: -13px;
}

.entrust-footer .el-icon-success {
    position: absolute;
    top: -15px;
}

.commission,
.commission-mark {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.commission-mark {
    background: rgba(0, 0, 0, .3);
    z-index: 1;
}

.commission-main {
    background: #fff;
    border-radius: 15px 15px 0 0;
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
    width: 100%;
}

.current-seller {
    display: flex;
    justify-content: space-between;
}

.cs-left,
.cs-right {
    width: 45%;
}

.cs-right {
    text-align: right;
}

.cs-block span {
    color: #999;
}

.cs-block div {
    color: #333;
}

.cs-block .proportion {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.cs-block .proportion i {
    width: 12px;
    height: 12px;
    display: block;
    background-image: url('/static/images/icon/arrow-right.png');
    background-size: cover;
}

.comm-title {
    font-size: 18px;
    text-align: center;
    padding: 10px;
    position: relative;
}

.comm-title .close {
    position: absolute;
    right: 15px;
    top: 15px;
}

.comm-list {
    text-align: center;
    padding: 20px;
}

/*委托代卖 step 2 选择商品*/
/* 商品行布局 */

/deep/ .entrust-sale-dialog.sale-dialog-2 .el-dialog__body {
    background: #fff;
}

.checkbox-wrapper {
    flex-shrink: 0;
}


/*委托代卖 step 3 确认商品*/
.cSeller-info-box {
    background-image: url('/static/images/vault/seller_bg.png');
    background-size: cover;
    /*background: #2059A1;*/
    color: #fff;
    padding: 20px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.cSeller-info-box .sel-info-header {
    padding-bottom: 0;
}

.cSeller-left {
    flex: 1;
    padding-right: 20px;
}

.go-shop {
    display: inline-block;
    background: url("/static/images/icon/shop.png") no-repeat 50% 50%;
    background-size: contain;
    width: 30px;
    height: 30px;
}

.code-name-box {
    background: #fff;
    padding: 10px 20px;
}

.code-name-box .cname-tips {
    color: #333;
    padding-bottom: 10px;
}

.code-name-box .cname-tips span {
    color: #A0A0A0;
}

/* 商品列表  */
.goods-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: -20px;
    background: #fff;
    z-index: 2;
}

.goods-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding: 8px 0;
    transition: all 0.3s;
    background: white;
    border-bottom: 1px solid #e4e7ed;
}

.goods-row:last-child {
    border-bottom: none;
}

.goods-row .el-checkbox {
    display: flex;
    width: 100%;
    align-items: center;
}

.goods-content {
    display: flex;
    flex: 1;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;
    min-width: 0;
    /* 防止内容溢出 */
}

.goods-img {
    width: 100px;
    height: 100px;
    min-width: 100px;
    border-radius: 4px;
    margin-right: 16px;
    background: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
}

.image-slot {
    color: #909399;
    font-size: 24px;
}

.goods-info {
    flex: 1;
    min-width: 0;
    /* 防止文本溢出 */
    margin-right: 16px;
}

.goods-title {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.goods-title.two-line {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 限制行数 */
    -webkit-box-orient: vertical;
    /* 垂直方向 */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    /* 必须为 normal */
    word-break: break-all;
    /* 允许单词内断行 */
    line-height: 1.5;
    /* 设置合适的行高 */
    max-height: 3em;
    /* 行高 * 行数 */
}

.goods-desc {
    font-size: 12px;
    color: #909399;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.goods-price {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin-bottom: 4px;
}

.status_tabs {
    border-radius: 5px;
    border: 1px solid #e0e0e0;
    display: inline-block;
    overflow: hidden;
    /* margin-top: 26px; */
}

.status_tabs span {
    padding: 9px 12px;
    cursor: pointer;
    float: left;
}

.status_tabs .active {
    color: #fff;
    background-color: #5F6DAE;
    font-weight: 700;
}

.status_tabs span+span {
    border-left: 1px solid #e0e0e0;
}

.status_bids_tabs {
    font-size: 12px;
}

.status_bids_tabs span {
    padding: 6px 8px;
}

.status_bids_tabs .active {
    font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/vault/entrust-sale.vue